import React, { useState} from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";

const OrderError = () => {
  const location = useLocation();
  const user = location.state?.user || null;
  // Cart State
    const [cart, setCart] = useState((location.state && location.state.cart) || []);
    const { message = null } = location.state || {};


  const toggleCartItem = (product) => {
    setCart((prevCart) => {
      const exists = prevCart.some((item) => item.name === product.name);
      return exists
        ? prevCart.filter((item) => item.name !== product.name)
        : [...prevCart, { ...product, quantity: 1 }];
    });
  };

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-gradient-to-tr from-blue-50 via-indigo-50 to-teal-50 p-6">
      {/* Header */}
      <Header
        cart={cart}
        user={user}
        showSearch={false}
        showCart={true}
        addToCart={toggleCartItem}
      />

      <section className="relative mt-6 rounded-xl overflow-hidden shadow-md border border-blue-200 flex flex-col">
        <h2 className="text-center text-xl font-bold text-blue-800 py-4 bg-gradient-to-r from-indigo-100 via-blue-100 to-teal-100 border-b border-blue-200">
          💳 Order Summary
        </h2>
      </section>
        <div className="flex-1 flex items-center justify-center">
          <div className="bg-red-100 text-red-700 border border-red-300 px-6 py-4 rounded-md text-center shadow-md max-w-md">
            ⚠️ {message}
          </div>
        </div>
    </div>
  );
};

export default OrderError;
